import {
  observable,
  transaction,
  map,
  computed,
  autorun,
  runInAction,
  action,
  toJS
} from 'mobx';
import QueryApi from '../api/QueryApi';
import PlanItem from './PlanItem';
import _merge from 'lodash/merge';


const filterItems = (items = [], groups, hiddenItems) => {

  
  
  // timetextbox 需求确认 不支持
  return items.filter(it => {
    if (hiddenItems && hiddenItems.length && hiddenItems.length > 0 && hiddenItems.indexOf(it.code) != -1) {
      return false;
    }
    if (it.type.toLowerCase() === 'timetextbox' || !it.visible) {
      return false;
    }
    if (it.group) {
      // 分组项只显示选中的，需求确认
      if (it.disabled) {
        return false;
      }
    }
    return true;
  });
}

export default class SearchModel {
  store;

  @observable name = null;
  @observable id = null;
  @observable type = null;
  @observable items = [];

  @observable error = null;

  @observable mustSearch = false;

  @observable loaded = false;

  @action clearError() {
    this.error = null;
  }

  constructor(store, planObj) {
    this.store = store;
    // this.id = planObj.id;
    // this.name = planObj.name;
    // this.type = planObj.type;
    this.bizCode = planObj.bizCode;
    this.isSystemList = planObj.isSystemList;
    this.codeName = planObj.codeName;
    this.externalParam = planObj.externalParam ? planObj.externalParam : null;
    this.hiddenItems = planObj.hiddenItems;
    this.items = [];
    this.loaded = this.items.length>0;
    this.info = {};
  }

  @action async load(refresh = false) {
    if (!this.loaded || refresh) {
      this.loaded = false;
      const info = this.isSystemList ? await QueryApi.getSystemItems(this.bizCode) : this.codeName ? await QueryApi.getPlanItemsByMenuCodeAndName(this.bizCode,this.codeName) : await QueryApi.getPlanItems(this.bizCode);
      this.id = info.id;
      this.name = info.name;
      this.type = info.type;
      this.info = info;
      let data;
      try {
        data = await QueryApi.getPlanData(this.id);
      } catch (err) {
        data = {};
        console.warn(err);
      }
      runInAction(() => {
        this.items = filterItems(info.items, info.groups, this.hiddenItems).map((item, i) => PlanItem.fromJS(this.store, this, item, data[item.code]));
        this.loaded = true;
      })
    }
  }

  @action async save() {
    const errors = this.items.map(it=>it.validate()).filter(success=>!success);
    if (errors.length>0){
      return;
    }
    try {
      if (this.type === 'user') {
        let data = this.items.reduce((obj, it) => {
          obj[it.code] = toJS(it.value);
          return obj;
        }, {})
        if(this.externalParam){
          _merge(data,this.externalParam);
        }
        this.isSystemList ? await QueryApi.saveSysPlanData(this.id,data ) : await QueryApi.savePlanData(this.id,data );
      } else {
        const {
          searchPlanId
        } = await QueryApi.copyPlanData(this.id, this.items.reduce((obj, it) => {
          obj[it.code] = toJS(it.value);
          return obj;
        }, {}));
        runInAction(() => {
          this.id = searchPlanId; // 生成个人方案id
          this.type = 'user';
          this.store.currentPlanId = searchPlanId; // 切换
        });
      }
      return true;
    } catch (err) {
      console.log(err);
      //setTip(true, 'error', err.message);
      return false;
    }
  }

  toJS() {
    return {
      id: this.id,
      name: this.name,
      items: this.items ? this.items.map(it => it.toJS()) : []
    }
  }

  static fromJS(store, obj, hiddenItems) {
    let items = filterItems(obj.items || [], obj.groups || [], hiddenItems || []);
    return new SearchModel(store, obj.id, obj.name, obj.type,
      items.map(it => PlanItem.fromJS(this.store, this, it)));
  }

}
